// extracted by mini-css-extract-plugin
export default {"prevButton":"RE_6Q__prevButton","nextButton":"KGTOJ__nextButton","flickityCarousel":"YTquH__flickityCarousel","carouselEntry":"fb3QK__carouselEntry","noTagsMsg":"vfE8d__noTagsMsg"};